import {
  PRODUCTS_ARE_FETCHING,
  PRODUCTS_FETCHED_SUCCESS,
  PRODUCTS_FETCHED_ERROR,
} from "../../../constants/actionTypes/actionTypes";
import { PRODUCTS_CLEAR_ERROR } from "../../../constants/actionTypes/actionTypes";
import getSubscriptionPlans from "../../../utils/getSubscriptionPlans";

const initialState = {
  plansAreFetching: false,
  subscriptionPlans: null,
  error: {
    status: null,
    errorMessage: "",
  },
};

// next line is excluded from a sonar because an order of variables is provided by redux
// prettier-ignore
export default (state = initialState, { type, payload }) => { //NOSONAR
  switch (type) {
    case PRODUCTS_ARE_FETCHING:
      return {
        ...state,
        plansAreFetching: true
      };
    case PRODUCTS_FETCHED_SUCCESS:
      return {
        ...state,
        plansAreFetching: false,
        subscriptionPlans: getSubscriptionPlans(payload),
      };
    case PRODUCTS_FETCHED_ERROR:
      return {
        ...state,
        plansAreFetching: false,
        error: payload
      };
    case PRODUCTS_CLEAR_ERROR:
      return {
        ...state,
        error: {
          status: null,
          errorMessage: ""
        }
      };
    default:
      return state;
  }
};
